import styled from 'styled-components'
import { Style } from '../../styles'

const ActivityFeedContainer = styled.div`
  margin-top: 20px;
  padding-top: 20px; 
  border-top: 1px solid ${Style.color.border};
`

export default ActivityFeedContainer